import PATH from "constants/path";
import {
  tvstation_1,
  tvstation_4,
  tvstation_5,
  tvstation_6,
  tvstation_7,
  tvstation_8,
} from "assets/img";

const LIST_MENU = [
  {
    path: PATH.TOP[0],
    name: "TOP",
  },
  {
    path: PATH.FIRST,
    name: "はじめての方へ",
  },
  {
    path: PATH.GUIDE,
    name: "ご利用方法",
  },
  {
    path: PATH.POINT,
    name: "ポイントについて",
  },
  {
    path: PATH.NEWS,
    name: "お知らせ",
  },
  {
    path: PATH.AREA_LIST,
    name: "収録会場",
  },
  {
    path: PATH.QUESTIONS,
    name: "よくあるご質問",
  },
  {
    path: PATH.CONTACT,
    name: "お問い合わせ",
  },
];

const LIST_IMAGE = [
  {
    path: "https://www.nhk.or.jp/",
    image: tvstation_1,
  },
  {
    path: "https://www.ntv.co.jp/pc/",
    image: tvstation_4,
  },
  {
    path: "https://www.tv-asahi.co.jp/",
    image: tvstation_5,
  },
  {
    path: "https://www.tbs.co.jp/",
    image: tvstation_6,
  },
  {
    path: "https://www.tv-tokyo.co.jp/",
    image: tvstation_7,
  },
  {
    path: "https://www.fujitv.co.jp/index.html",
    image: tvstation_8,
  },
];

export { LIST_MENU, LIST_IMAGE };
